import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { UserAuth } from "../../context/AuthContext";
import { useLang } from "../../i18n/LanguageContext";
import { TERMS_VERSION } from "../../legal/config";

// Pages lisibles sans avoir accepté (pour pouvoir lire les textes avant d'accepter)
const LEGAL_PAGES = ["/cgv", "/confidentialite", "/mentions-legales"];

/**
 * Demande aux utilisateurs connectés d'accepter les conditions en vigueur
 * (comptes créés avant leur mise en place, ou après une nouvelle version).
 */
const TermsGate = () => {
  const { user, refreshUser, logOut } = UserAuth();
  const { t } = useLang();
  const { pathname } = useLocation();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!user?.hasProfile || user.termsVersion === TERMS_VERSION || LEGAL_PAGES.includes(pathname)) return null;

  const accept = async () => {
    setSaving(true);
    setError("");
    try {
      await updateDoc(doc(db, "users", user.uid), {
        termsAcceptedAt: new Date().toISOString(),
        termsVersion: TERMS_VERSION,
      });
      await refreshUser();
    } catch (e) {
      console.error(e);
      setError(t("Une erreur est survenue. Veuillez réessayer."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center px-4" role="dialog" aria-modal="true" aria-labelledby="terms-title">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-7">
        <h2 id="terms-title" className="font-display font-bold text-2xl text-prune-deep mb-3">
          {t("Nos conditions évoluent")}
        </h2>
        <p className="text-sm text-stone-700 leading-relaxed mb-5">
          {t("Pour continuer à utiliser Tatie Soso, merci de lire et d'accepter nos conditions générales et notre politique de confidentialité.")}
        </p>
        <label className="flex items-start gap-3 text-sm text-stone-700 cursor-pointer mb-5">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-1 w-4 h-4 accent-prune shrink-0"
          />
          <span>
            {t("J'accepte les")}{" "}
            <Link to="/cgv" target="_blank" className="text-prune underline">{t("conditions générales")}</Link>{" "}
            {t("et j'ai lu la")}{" "}
            <Link to="/confidentialite" target="_blank" className="text-prune underline">{t("politique de confidentialité")}</Link>.
          </span>
        </label>
        {error && <p className="text-sm text-red-700 mb-3">{error}</p>}
        <button
          onClick={accept}
          disabled={!checked || saving}
          className="w-full py-3 rounded-full bg-prune text-white font-bold hover:bg-prune-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {saving ? t("Enregistrement...") : t("Continuer")}
        </button>
        <button onClick={logOut} className="w-full py-2 mt-2 text-sm text-stone-600 hover:text-stone-800">
          {t("Déconnexion")}
        </button>
      </div>
    </div>
  );
};

export default TermsGate;
